<ng-template #template>
  <div class="modal-header header-style">
    <h3 class="modal-title pull-left">Dental Practice Request</h3>
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">  
      <span aria-hidden="true"><img class="resize" src="assets/img/icons/icn-remove-dark.svg" alt="close"></span>  
    </button>  
  </div>
  <div class="modal-body bod-text">
    <div class="container-fluid">
      <div class="row mb-4 info-text">
        Please make your request as a dental practice below and include any specifics in your request details. All fields are required unless marked optional.
      </div>
      <div class="row mb-2 option-text">
        What type of update are you requesting?
      </div>
      <!-- radio-selection section -->
      <div class="selection-panel">
        <ul class="list-group list-group-radio">
          <li class="list-group-item">
            <label  class="radio-label">
              <input  type="radio"
                  class="mr-1"
                  name="radio2"
                  aria-label="New Practice"
                  [checked]=" (num == 1)"
                  aria-labeledby="Radio_Buttons"
                  (click)="showForm('NEW')">
                  <span>New Practice</span>
              <div class="subtle-text">I need to add a new dental practice to United Concordia.</div>
              <span class="checkmark"></span>
            </label>
          </li>
          <li class="list-group-item">
            <label class="radio-label">
              <input type="radio"
                  class="mr-1"
                  name="radio2"
                  aria-label="Maintenance"
                  [checked]=" (num == 2)"
                  aria-labeledby="Radio_Buttons"
                  (click)="showForm('MAINTENANCE')">
              <span>Maintenance</span>
              <div class="subtle-text">I need to update existing information for a provider in my dental practice.</div>
              <span class="checkmark"></span>
            </label>
          </li>
          <li class="list-group-item">
            <label class="radio-label">
                <input type="radio"
                    class="mr-1"
                    name="radio2"
                    [checked]=" (num == 3)"
                    aria-label="Resign Participation"
                    aria-labeledby="Radio_Buttons"
                    (click)="showForm('RESIGNATION')"> 
                    <span>Resign Participation</span>
                <div class="subtle-text">I need to inform you of a resignation.</div>
                <span class="checkmark"></span>
              </label>
          </li>
        </ul>
      </div>
      <!-- end of radio selection section -->
    </div>
  </div>  
  <div *ngIf="blank">
    <app-blank-component></app-blank-component>
  </div>
  <div *ngIf="new">
    <app-group-new></app-group-new>
  </div>
  <div *ngIf="maintenance">
    <app-group-maintenance></app-group-maintenance>
  </div>
  <div *ngIf="resignation">
    <app-group-resignation></app-group-resignation>
  </div>
</ng-template>  

